import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import front from '@/../static/js/proto/CtpFront';

/**
 * 选择合约的键盘
 */
@Component({
  name: 'TargetKeyboard',
})
export default class TargetKeyboard extends Vue {
  @Prop()
  public exclude: Node | Node[] | ((current: Node) => boolean);

  public sumExchangeName = ['自选', '上期所', '上期能源', '大商所', '郑商所', '中金所', '广期所'];
  public contractData = [];
  public currentExchangeName = '自选';
  public currentProductId = '';
  public selectFage: boolean = true;

  public get selectTarget(): any {
    return this.$store.state.selectTargets;
  }

  public mounted() {
    this.loader_key();
  }

  public choiceProduceId(productId) {
    this.currentProductId = productId;
  }
  // 键盘选择合约时触发事件
  public choiceTargetId(targetId) {
    this.passValueToP(targetId);
  }

  // 选择交易所
  public choiceExchangeName(item) {
    this.currentExchangeName = item;

    if (item === '上期所') {
      this.selectFage = true;
      this.currentProductId = 'ag';
    } else if (item === '大商所') {
      this.selectFage = true;
      this.currentProductId = 'a';
    } else if (item === '郑商所') {
      this.selectFage = true;
      this.currentProductId = 'AP';
    } else if (item === '中金所') {
      this.selectFage = true;
      this.currentProductId = 'IC';
    } else if (item === '上期能源') {
      this.selectFage = true;
      this.currentProductId = 'sc';
    } else if (item === '广期所') {
      this.selectFage = true;
      this.currentProductId = 'si';
    } else if (item === '自选') {
      this.selectFage = false;
      this.currentProductId = '';
    }
  }

  public loader_key() {
    this.contractData = (front as any).targetList;
    this.selectFage = false;
    // console.log(this.selectTarget);
  }

  public handleClose() {
    this.$emit('close');
  }
  public passValueToP(targetId) {
    this.$emit('submit', targetId);
    this.$emit('close');
  }
}



// WEBPACK FOOTER //
// ./src/views/components/TargetKeyboard/TargetKeyboard.ts